<template>
	<div class="flex flex-col min-h-dvh app">
		<div class="flex-1 pb-4">
			<Nuxt keep-alive :keep-alive-props="{ max: 5 }" />
		</div>
		<ToastContainerComponent />
		<FooterComponent :reserve-cookie-banner-space="true" />
		<client-only>
			<CookieBanner @open-settings="showCookieSettings = true" />
			<CookieSettingsModal
				v-if="showCookieSettings"
				@close="showCookieSettings = false"
			/>
		</client-only>
	</div>
</template>

<script>
import FooterComponent from '~/components/footer'
import ToastContainerComponent from '~/components/toast-container'
import CookieBanner from '~/components/ui/banners/CookieBanner'
import CookieSettingsModal from '~/components/ui/modals/CookieSettingsModal'

export default {
	head() {
		return {
			meta: [
				{ hid: 'robots', name: 'robots', content: 'noindex, nofollow' }
			]
		}
	},
	middleware: ['auth'],
	components: {
		FooterComponent,
		ToastContainerComponent,
		CookieBanner,
		CookieSettingsModal
	},
	data() {
		return {
			showCookieSettings: false
		}
	}
}
</script>
